// extracted by mini-css-extract-plugin
export var animationContainer = "_i0-0";
export var asteriskIcon = "_i0-8";
export var conversationLeftSection = "_i0-4";
export var conversationListItem = "_i0-3";
export var conversationMiddleSection = "_i0-5";
export var conversationRightSection = "_i0-6";
export var detailsContent = "_i0-1";
export var listContainer = "_i0-7";
export var modalContent = "_i0-2";